import { render, staticRenderFns } from "./addCustomDialog.vue?vue&type=template&id=41f68a4b&scoped=true"
import script from "./addCustomDialog.vue?vue&type=script&lang=js"
export * from "./addCustomDialog.vue?vue&type=script&lang=js"
import style0 from "./addCustomDialog.vue?vue&type=style&index=0&id=41f68a4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f68a4b",
  null
  
)

export default component.exports